module.exports = __webpack_public_path__ + "components/nearby/static/nearby-location--white-166cb95289290aabc74ca4b0b5843647.svg";